import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TtButton, TtIcon, TtTooltip } from '@23/react'
import { intl } from 'lang/intl'
// @ts-expect-error — importing js
import { generateActions } from '../../../../sharedLegacy/utils/bundleFeature'

export const VideoPlayback = () => {
  const isPanelVisible = useSelector((state: any) => {
    if (state['feature-webinar-room-sidebar'] !== undefined) {
      const { isSecondaryPanelVisible, secondaryPanelContentType } =
        state['feature-webinar-room-sidebar']
      return isSecondaryPanelVisible && secondaryPanelContentType === 'playback'
    }
    return false
  })

  const dispatch = useDispatch()
  const { actionNames } = generateActions('webinar-room-sidebar', [
    'TOGGLE_SECONDARY_PANEL',
  ])
  const togglePlaybackPanel = () =>
    dispatch({
      type: actionNames.TOGGLE_SECONDARY_PANEL,
      payload: ['playback'],
    })

  const getTooltipContent = useCallback(() => {
    return isPanelVisible
      ? intl.formatMessage({ defaultMessage: 'Hide video playback panel' })
      : intl.formatMessage({ defaultMessage: 'Show video playback panel' })
  }, [isPanelVisible])

  type ButtonColor = HTMLTtButtonElement['color']

  const buttonColor: ButtonColor = isPanelVisible ? 'primary' : 'secondary'

  return (
    <TtTooltip content={getTooltipContent()} placement="left" distance={16}>
      <TtButton circle onClick={togglePlaybackPanel} color={buttonColor}>
        <TtIcon library="one/webinars" name="single-video" />
      </TtButton>
    </TtTooltip>
  )
}
